import { Fragment } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Row } from "@/libraries/wpl/foundations/src";

const logosContainerStyle = css({
    justifyItems: "center",
    alignItems: "center",
    marginBlockStart: 48,
    marginBlockEnd: 32,
    marginInline: "auto",
    width: "100%",

    [media.above.md]: {
        maxWidth: 965,
        justifyContent: "space-evenly"
    },
    [media.above.sm]: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        rowGap: 24,
        columnGap: 48,
        width: "100%"
    },
    [media.only.sm]: {
        maxWidth: 700
    },
    [media.below.sm]: {
        display: "grid",
        rowGap: 16,
        columnGap: 24,
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        maxWidth: 700,
        width: "100%"
    },
    [media.below.xs]: {
        display: "grid",
        rowGap: 8,
        columnGap: 16,
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});

const logoStyle = css({
    pointerEvents: "none",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)",

    [media.below.sm]: {
        transform: "scale(0.7)"
    },
    [media.only.sm]: {
        transform: "scale(0.8)"
    }
});

export const SocialEndorsement = () => {
    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg",
            alt: "Canva",
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg",
            alt: "NASA",
            width: 60
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg",
            alt: "Illumina",
            width: 103
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg",
            alt: "Docker",
            width: 108
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg",
            alt: "The New York Times",
            width: 165
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg",
            alt: "Audi",
            width: 68
        }
    ];

    return (
        <Row>
            <div css={logosContainerStyle}>
                {logos.map((logo, index) => (
                    <Fragment key={index}>
                        {/* eslint-disable-next-line no-restricted-syntax */}
                        <img
                            src={logo.src}
                            css={logoStyle}
                            alt={logo.alt}
                            loading="lazy"
                            width={logo.width}
                        />
                    </Fragment>
                ))}
            </div>
        </Row>
    );
};
